import { useState } from 'react'
import { Icon } from './Icon'

export interface ThumbProps {
  /** Готовые адреса фотографий товара; пусто — рисуем заглушку. */
  photos: string[]
  size?: number
  /** Подпись для читалки: без неё картинка товара остаётся безымянной. */
  alt?: string
  /** Размер задаёт раскладка (ячейка сетки фото), а не число в пикселях. */
  fluid?: boolean
}

/**
 * Картинка товара в таблице. Адреса приходят готовыми из API и собирать их
 * самим нельзя: файлы переедут в объектное хранилище, а поле останется тем же.
 * Товара без фотографии в каталоге быть не должно — поэтому пустое место
 * показано значком, а не пустотой: это рабочее состояние, а не оформление.
 *
 * Файл, который не загрузился, тоже становится заглушкой: иначе браузер
 * рисует вместо картинки её подпись, и она вылезает за квадрат. Заглушка
 * нейтральная: цвет категории в таблице превращал список в пёструю ленту.
 */
export function Thumb({ photos, size = 44, alt = '', fluid = false }: ThumbProps) {
  const photo = photos[0]
  const [broken, setBroken] = useState<string | null>(null)
  const style = fluid ? undefined : { width: size, height: size }

  if (photo && broken !== photo) {
    return (
      <img
        className="ui-thumb"
        src={photo}
        alt={alt}
        style={style}
        loading="lazy"
        onError={() => {
          setBroken(photo)
        }}
      />
    )
  }

  return (
    <div
      className="ui-thumb"
      aria-hidden="true"
      data-broken={photo ? true : undefined}
      style={style}
    >
      <Icon name="i-img" size={fluid ? 24 : Math.round(size * 0.45)} />
    </div>
  )
}
